import dynamic from 'next/dynamic';
import { SubmitInquiryProps } from './SubmitInquiry.types';

export const SubmitInquiry = dynamic<{ model: SubmitInquiryProps }>(() =>
  import('./SubmitInquiry').then(mod => mod.SubmitInquiry)
);
